const snapshotDialogSx = (theme) => ({
    inputWrapper: {
        padding: theme.spacing(2),
    },
});

export default snapshotDialogSx;
